export const CLIENTS_ROUTES = {
    CREATE: "/{service_company_slug}/clients/create/",
    LIST: "/{service_company_slug}/clients/",
    COUNT: "/{service_company_slug}/api/clients/count/",
    LIGHTWEIGHT_LIST: "/{service_company_slug}/api/clients/lightweight/",
    DETAILS: "/{service_company_slug}/clients/{id}/",
}
